import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export default function CartProvider({ children }) {

  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem("cart");
    return saved ? JSON.parse(saved) : [];
  });

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // ── UNIQUE KEY: same product in diff size/color = separate cart entry ──
  const makeKey = (id, size, color) => `${id}__${size || "default"}__${color || "default"}`;

  // Add to cart — now accepts selectedSize and selectedColor
  const addToCart = (product, selectedSize = null, selectedColor = null) => {
    const key = makeKey(product._id, selectedSize, selectedColor);
    const existing = cart.find(item => item._cartKey === key);

    if (existing) {
      setCart(cart.map(item =>
        item._cartKey === key
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, {
        ...product,
        selectedSize,
        selectedColor,
        quantity: 1,
        _cartKey: key
      }]);
    }
  };

  // Remove by cart key
  const removeFromCart = (cartKey) => {
    setCart(cart.filter(item => item._cartKey !== cartKey));
  };

  // Increase quantity by cart key
  const increaseQty = (cartKey) => {
    setCart(cart.map(item =>
      item._cartKey === cartKey ? { ...item, quantity: item.quantity + 1 } : item
    ));
  };

  // Decrease quantity by cart key
  const decreaseQty = (cartKey) => {
    setCart(cart
      .map(item =>
        item._cartKey === cartKey
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
      .filter(item => item.quantity > 0)
    );
  };

  return (
    <CartContext.Provider value={{
      cart,
      addToCart,
      removeFromCart,
      increaseQty,
      decreaseQty
    }}>
      {children}
    </CartContext.Provider>
  );
}